<template >
    <div class="header-tools-item d-flex" @click="$emit('click')">
        <button 
            class="header-tools-item__button button button_size_small button_color_transp-black button_with_icon"
            :class="{'button_type_active':this.$store.getters.telList.value}"
            @click="handlerClick"
            title="Список операторов"
        >
            
            <div class="header_button_icon header-tools-item__icon">
                <svg aria-hidden="true" width="20" height="20">
                    <use href="#icon-phone-3"></use> 
                </svg>
            </div>

            <div class="header-tools-item__text is-desktop-hide">
                Список операторов
            </div>
        </button>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    mounted() {
        localStorage.getItem('telList') === 'true' && this.CHANGE_ACTIVE_BAR({name:'telList', value:true})
    },
    methods: {
        ...mapActions([
            'SET_BAR',
            'CHANGE_ACTIVE_BAR'
        ]),

        handlerClick() {
            const value = !this.$store.getters.telList.value
            this.CHANGE_ACTIVE_BAR({name:'telList', value})
            localStorage.setItem('telList', value)
        },
    },
}
</script>
<style lang="scss">
.header-tools-item {
    & &__button {
        margin-right: 0;
    }
}
</style>